import Vue from 'vue';
import {Message} from 'element-ui';
import router from './../router';
import * as appUtils from './appUtils';
import qs from 'qs';
import axios from 'axios';
import {ConstStatic} from './../core/constStatic';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios);


export const HttpServer = {
  get: function get(url, data = {}, showTips = false, needToken = true) {
    let promise = new Promise(function (resolve, reject) {
      let headers = setHeader(needToken);
      data['appId'] = data['appId'] ? data['appId'] : appUtils.getAppId();
      axios.get(url, {params: data, 'headers': headers}, showTips).then((res) => {
        if (res.data.status == 0) {
          resolve(res.data);
        } else {
          reject();
        }
        showMessage(res.data, showTips);
      }).catch((err) => {
        reject(err);
        showMessage({'status': -1, 'message': '网络错误'}, showTips);
      });
    });
    return promise;
  },
  post: function post(url, data = {}, showTips = false, needToken = true) {
    let promise = new Promise(function (resolve, reject) {
      let headers = setHeader(needToken);
      let appId = data['appId'] ? data['appId'] : appUtils.getAppId();
      url = appUtils.formatDataToUrl({'appId': appId}, url);
      axios.post(url, data, {'headers': headers}).then((res) => {
        if (res.data.status == 0) {
          resolve(res.data);
        } else {
          reject();
        }
        showMessage(res.data, showTips);
      }).catch((err) => {
        showMessage({'status': -1, 'message': '网络错误'}, showTips);
        reject(err);
      });
    });
    return promise;
  },
  put: function put(url, data = {}, showTips = false, needToken = true) {
    let promise = new Promise(function (resolve, reject) {
      let headers = setHeader();
      let appId = data['appId'] ? data['appId'] : appUtils.getAppId();
      url = appUtils.formatDataToUrl({'appId': appId}, url);
      axios.put(url, data, {'headers': headers}).then((res) => {
        if (res.data.status == 0) {
          resolve(res.data);
        } else {
          reject();
        }
        showMessage(res.data, showTips);
      }).catch((err) => {
        showMessage({'status': -1, 'message': '网络错误'}, showTips);
        reject(err);
      });
    });
    return promise;
  },
  delete: function delet(url, data = {}, showTips = false, needToken = true) {
    let promise = new Promise(function (resolve, reject) {
      let headers = setHeader();
      data['appId'] = data['appId'] ? data['appId'] : appUtils.getAppId();
      axios.delete(url, {params: data, 'headers': headers}, showTips).then((res) => {
        if (res.data.status == 0) {
          resolve(res.data);
        } else {
          reject();
        }
        showMessage(res.data, showTips);
      }).catch((err) => {
        reject(err);
        showMessage({'status': -1, 'message': '网络错误'}, showTips);
      });
    });
    return promise;
  },
  deleteBody: function delet(url, data = {}, showTips = false, needToken = true) {
    let promise = new Promise(function (resolve, reject) {
      let headers = setHeader();
      let appId = data['appId'] ? data['appId'] : appUtils.getAppId();
      url = appUtils.formatDataToUrl({'appId': appId}, url);
      axios.delete(url, {data: data}, {'headers': headers}).then((res) => {
        if (res.data.status == 0) {
          resolve(res.data);
        } else {
          reject();
        }
        showMessage(res.data, showTips);
      }).catch((err) => {
        reject(err);
        showMessage({'status': -1, 'msg': '网络错误'}, showTips);
      });
    });
    return promise;
  },
  postForm: function post(url, data = {}, showTips = false) {
    let promise = new Promise(function (resolve, reject) {
      let headers = setFormHeader();
      url = appUtils.getSignWithUrl(url);
      let appId = data['appId'] ? data['appId'] : appUtils.getAppId();
      url = appUtils.formatDataToUrl({'appId': appId}, url);
      data = qs.stringify(data);
      axios.post(url, data, {'headers': headers}).then((res) => {
        if (res.data.status == 0) {
          resolve(res.data);
        } else {
          reject(res.data);
        }
        showMessage(res.data, showTips);
      }).catch((err) => {
        showMessage({'status': -1, 'message': '网络错误'}, showTips);
        reject(err);
      });
    });
    return promise;
  },
  postForm1: function post(url, data = {}, showTips = false) {
    let promise = new Promise(function (resolve, reject) {
      let headers = setFormHeader();
      url = appUtils.getSignWithUrl(url);
      let appId = data['appId'] ? data['appId'] : appUtils.getAppId();
      url = appUtils.formatDataToUrl({'appId': appId}, url);
      axios.post(url, data, {'headers': headers}).then((res) => {
        if (res.data.status == 0) {
          resolve(res.data);
        } else {
          reject(res.data);
        }
        showMessage(res.data, showTips);
      }).catch((err) => {
        showMessage({'status': -1, 'message': '网络错误'}, showTips);
        reject(err);
      });
    });
    return promise;
  },
  postForm2: function post(url, data = {}, showTips = false) {
    let promise = new Promise(function (resolve, reject) {
      let headers = setHeader();
      url = appUtils.getSignWithUrl(url);
      let appId = data['appId'] ? data['appId'] : appUtils.getAppId();
      url = appUtils.formatDataToUrl({
        'appId': appId
      }, url);
      // data = qs.stringify(data);
      axios.post(url, data, {
        'headers': headers
      }).then((res) => {
        if (res.data.status == 0) {
          resolve(res.data);
        } else {
          reject(res.data);
        }
        showMessage(res.data, showTips);
      }).catch((err) => {
        showMessage({
          'status': -1,
          'message': '网络错误'
        }, showTips);
        reject(err);
      });
    });
    return promise;
  },
  getForm: function post(url, data = {}, showTips = false) {
    let promise = new Promise(function (resolve, reject) {
      let headers = setFormHeader();
      url = appUtils.getSignWithUrl(url);
      let appId = data['appId'] ? data['appId'] : appUtils.getAppId();
      url = appUtils.formatDataToUrl({'appId': appId}, url);
      axios.get(url, {params: data, 'headers': headers}, showTips).then((res) => {
        if (res.data.status == 0) {
          resolve(res.data);
        } else {
          reject(res.data);
        }
        showMessage(res.data, showTips);
      }).catch((err) => {
        showMessage({'status': -1, 'message': '网络错误'}, showTips);
        reject(err);
      });
    });
    return promise;
  }
};
function setHeader(needToken) {
  let headers = {
    'Content-Type': 'application/json'
  };
  if (needToken) {
    if (!appUtils.getToken()) {
      showMessage({'status': 1001, 'message': '登录过期'}, true);
    }
    Object.assign(headers, {'Authorization': 'Bearer ' + appUtils.getToken()});
  }
  return headers;
}
function setFormHeader() {
  let headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  return headers;
}
function showMessage(res, showTips) {
  if (!res) {
    return;
  }
  let type = '';
  switch (Number(res.status)) {
    case 0:
      type = 'success';
      break;
    case 1:
      type = 'error';
      break;
    case -1:
      type = 'error';
      break;
    case 3:
      type = 'error';
      showTips = true;
      break;
    case 1001:
      type = 'error';
      showTips = false;
      res.message = '登录过期,请重新登录';
      appUtils.removeLocalStorage(ConstStatic.TOKEN_KEY);
      appUtils.removeLocalStorage(ConstStatic.USER_INFO);
      appUtils.removeLocalStorage(ConstStatic.JTI);
      router.push({
        // path: '/login'
      });
      break;
    default:
      type = 'error';
      break;
  }
  if (showTips) {
    Message({
      showClose: true,
      customClass: 'messageZindex',
      message: res.message ? res.message : '网络错误',
      type: type
    });
  }
}




// WEBPACK FOOTER //
// ./src/core/http.server.js